<template>
  <div class="media-time">
    <icon data="@icon/time.svg" />
    {{ formattedTime }}
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  durationInSeconds: {
    type: Number,
    default: 0,
  },
});

const formattedTime = computed(() => {
  const hours = Math.floor(props.durationInSeconds / 3600);
  const minutes = Math.floor((props.durationInSeconds % 3600) / 60);
  const seconds = Math.floor(props.durationInSeconds % 60);

  const formattedHours = hours.toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");
  const formattedSeconds = seconds.toString().padStart(2, "0");

  return `${
    hours == 0 ? "" : formattedHours + ":"
  }${formattedMinutes}:${formattedSeconds}`;
});
</script>

<style lang="scss" scoped>
.media-time {
  @include link-s;

  padding: 1rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
</style>
